import { AbstractResource } from '../AbstractResource'

class McRequestForgotPasswordResource extends AbstractResource {
  _endpointUrl = '/auth/forgot_passwords'
}

export { McRequestForgotPasswordResource }
